import { useEffect, useRef, useState } from "react";
import { postData } from "../../ApiServices/ApiService";
import { ORG_EMP_SEARCH_TO_ADD_TEAMMEMBER,ORG_DISBURSEMENT_APPROVALS } from "../../ApiServices/BaseURL";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";

const DisbursementsApprovalsController = (disbursementApproveList, onRefresh, setDisbursementApproveError,setDisbursementApproveLoading,setDisbursementApproveList) => {
    const pageName = "DisbursementsApprovalsController";
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const [currentPage, setCurrentPage] = useState(1);
    const [employeeList, setEmployeeList] = useState([]);
    const [employeeLoading, setEmployeeLoading] = useState(false);
    const [employeeError, setEmployeeError] = useState("");
    const [filterError, setFilterError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [filters, setFilters] = useState({
        employee: "",
        date: "",
        amount: "",
        status: null,
        emp_id: null,

    });
    const statusOptions = [
      { label: "Approval Pending", value: "2" },
      { label: "Approved", value: "3" },
      { label: "Partially Approved", value: "4" },
      { label: "Rejected", value: "5" },
    ];
    const [approvalDisbursementList, setApprovalDisbursementList] = useState([]);
    const [loading, setLoading] = useState(false);
    const { setIsLoginPopup } = useTheme();
    const handleChange = (name, value) => {
        setFilters((prev) => {
            // If user manually changes the employee name, reset employee_id
            if (name === "employee") {
                return { ...prev, employee: value, employee_id: null };
            }
            return { ...prev, [name]: value };
        });
    };
    const [disbursements, setDisbursements] = useState ([
        {
            date: '11/12/2024',
            approvedDate: '11/12/2024',
            employee: 'John Doe',
            amount: 500,
            approvedBy: 'Bharat R.',
        },
        // add more dummy or real data
    ]);

    const [filterLength, setFilterLength] = useState(0);

    const handleSearchEmployee = async () => {
        setEmployeeLoading(true);
        setEmployeeError("");
        setEmployeeList([]);
        setOpenDropdown(null)

        const query = filters.employee.trim();
        if (!query) {
            setEmployeeError("Please enter a name to search.");
            setEmployeeLoading(false);
            return;
        }

        try {
            const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                search_type: "GENERIC",
                search_word: query,
            };

            const response = await postData(ORG_EMP_SEARCH_TO_ADD_TEAMMEMBER, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
              if (responseData.statusCode === 200) {
                if (responseData?.message?.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                      setEmployeeList(responseData?.dataJ);
                  } else {
                    setEmployeeError(responseData?.info || "No employees found.");
                  }
                } else {
                  setEmployeeError(responseData?.info || "Failed to fetch employees. Please try again.");
                  logFrontendException(storedUserId, pageName, "handleSearchEmployee", responseData?.info || '');
                }
              } else {
                setEmployeeError(responseData?.info || "Error while fetching employees.");
                logFrontendException(storedUserId, pageName, "handleSearchEmployee", responseData || '');
              }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              setEmployeeError('Unauthorized access. Your session may have expired. Please log in again.');
              logFrontendException(storedUserId, pageName, "handleSearchEmployee", responseData || '');
              setIsLoginPopup(true)      
            } else {
                setEmployeeError(responseData?.info || "Failed to fetch employees.");
                logFrontendException(storedUserId, pageName, "handleSearchEmployee", response || '');
            }
        } catch (err) {
            setEmployeeError("Search failed. Please check your internet connection and try again.");
            logFrontendException(storedUserId, pageName, "handleSearchEmployee", err || '');
        } finally {
            setEmployeeLoading(false);
        }
    };

    const handleSelectEmployee = (employee) => {
        setFilters((prev) => ({
            ...prev,
            employee: employee?.emp_name || "",
            emp_id: employee?.emp_id || null,
        }));
        setEmployeeList([]);
    };

    const [disbursementData, setDisbursementData] = useState(null)
    const handleApproveReject = (item) => {
        setShowModal(true);
        setDisbursementData(item)
        console.log("Handle Approve/Reject", item);
      };

    const applyFiltersApproveList = async () => {
      console.log("filters1", filters)
        setFilterError(""); // Clear any previous error
        setDisbursementApproveError('');
        const { employee, ...restFilters } = filters;
    
        const isAnyFilterApplied = Object.values(restFilters).some(
          (val) => val !== null && val !== undefined && String(val).trim() !== ""
        );
      
        if (!isAnyFilterApplied) {
          setFilterError("Please apply at least one filter to proceed.");
          return;
        }
      
        setApprovalDisbursementList([]);
        setLoading(true);
        setCurrentPage(1);
        try {
          const payload = {
            emp_id_auth: storedUserId,
            action_type: "disbursement_approval_list_filter",
            employee_id: filters.emp_id || null,
            expense_date: filters.date || null,
            amount: filters.amount || null,
            status: filters.status?.value ?? null
          };
          
          console.log("payload in DisbursementsApprovals flter", payload)
          // return
          const response = await postData(ORG_DISBURSEMENT_APPROVALS, payload);
          const responseData = await response.json();
          if (response.status === 200 && responseData.status_code === 200) {
            if (responseData.message.toLowerCase() === "success") {
              if (responseData?.dataJ?.length > 0) {
                setFilterLength(responseData?.dataJ?.length);
                setApprovalDisbursementList(responseData?.dataJ || []);
              } else {
                setDisbursementApproveError(responseData?.info || "Error while fetching disbursement.");
                logFrontendException(storedUserId, pageName, "applyFiltersApproveList", responseData?.info || '');
    
              }
            } else {
              setDisbursementApproveError(responseData?.info || "Failed to fetch disbursement.");
              // Log exception to backend (User Id,Page Name,Method Name,Response/error)
              logFrontendException(storedUserId, pageName, "applyFiltersApproveList", responseData || '');
            }
          } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
            setDisbursementApproveError('Unauthorized access. Your session may have expired. Please log in again.');
              setIsLoginPopup(true)
              // Log exception to backend (User Id,Page Name,Method Name,Response)
              logFrontendException(storedUserId, pageName, "applyFiltersApproveList", responseData || '');
                  
          } else {
            setDisbursementApproveError(responseData?.info || "Failed to fetch disbursement.Please try again.");
            // Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "applyFiltersApproveList", responseData || response || '');
          }
        } catch (err) {
          setDisbursementApproveError("Failed to fetch disbursement. Please check your internet connection and try again.");
          logFrontendException(storedUserId, pageName, "applyFiltersApproveList-catch", err || '');
        } finally {
          setLoading(false);
        }
      };
    
      const resetFilters = () => {
        setFilterError('');
        setDisbursementApproveError('');
        setFilters({ employee: "", date: "", amount: "", status: null, emp_id: null, });
        onRefresh()
        setApprovalDisbursementList([]);
        setEmployeeList([]);
        setFilterLength(0);
      };

      const dropdownRefs = useRef({});

      useEffect(() => {
        if(disbursementApproveList) {
          setApprovalDisbursementList(disbursementApproveList);
        }
    }, [disbursementApproveList]);

    useEffect(() => {
        setFilterLength(0);
    }, []);

      useEffect(() => {
        const handleClickOutside = (event) => {
          const isOutside = Object.keys(dropdownRefs.current).every(
            (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
          );
          if (isOutside) {
            setOpenDropdown(null);
            setEmployeeList([])
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);

      const toggleDropdown = (name) => {
        setOpenDropdown((prev) => (prev === name ? null : name));
        setEmployeeList([]);
      };

    const itemsPerPage = 5;
    const totalPages = Math.ceil(approvalDisbursementList?.length / itemsPerPage);
  
    const currentDisbursements = approvalDisbursementList?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handlePageChange = (page) => {
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };
  
    const getVisiblePages = () => {
      const maxPages = 3;
      const start = Math.max(1, currentPage - 1);
      const end = Math.min(totalPages, start + maxPages - 1);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };
  
    const visiblePages = getVisiblePages();

     const getStatusStyle = (item) => {
        const status = item?.disburse_status;
        switch (status) {
        case 5:
            return { backgroundColor: "#C7C4C32E", color: "#7B7B7B" }; // Gray
        case 2:
            return { backgroundColor: "#EE201C2E", color: "#EE201C" };
        case 4:
            return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
        case 3:
            return { backgroundColor: "#1A932E2E", color: "#1A932E" };
    
        // return { backgroundColor: "#E65F2B2E", color: "#E65F2B" };
        default:
            return {};
        }
            };
    const getStatusLabel = (status) => {
        switch (status) {
            case 2:
            return "Request Pending";
            case 3:
            return "Request Approved";
            case 4:
            return "Partially Approved";
            case 5:
            return "Rejected";
            default:
            return "Unknown Status";
        }
    };

    const filterOnRefresh = () => {
      if (filterLength === 0 || filterLength === 1) {
          setFilterError('')
          setFilters({ employee: "", date: "", amount: "", status: null, emp_id: null, });
          onRefresh()
          setEmployeeList([]);
      } else {
          applyFiltersApproveList();
      }
    }

    return {
        disbursements,
        handleChange,
        filters,
        setFilters,
        handleSelectEmployee,
        handleSearchEmployee,
        employeeError,
        employeeList,
        employeeLoading,
        filterError,
        showModal,
        closeModal: () => setShowModal(false),
        handleApproveReject,
        disbursementData,
        applyFiltersApproveList,
        resetFilters,
        toggleDropdown,
        dropdownRefs,
        openDropdown,
        statusOptions,
        visiblePages,
        handlePageChange,
        approvalDisbursementList: currentDisbursements,
        currentPage,
        totalPages,
        getStatusLabel,
        getStatusStyle,
        loading,
        filterOnRefresh,

    }
}

export default DisbursementsApprovalsController